module.exports = __webpack_public_path__ + "img/image-menu-2.dc4709c.jpg";